<span
  [matTooltip]="text"
  [matTooltipClass]="tooltipClass"
  attr.aria-label="{{ariaLabel}}"
  [matTooltipPosition]="tooltipPosition"
>
  <mmp5-mm-icons [ngClass]="[class || '']" [icon]="icon" ></mmp5-mm-icons>
</span>
